import * as types from "./TopUpActionType";
const initialState = {
    topUpListData: [],
}
const TopUpReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.TOP_UP_LIST:
            return {
                ...state,
                topUpListData: [...action.payload]
            };
        default:
            return state;
    }
}

export default TopUpReducer
